import React, { useState, useRef } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import axios from 'axios';
import storage from '../utils/storage';
import { useFormik } from 'formik';
import { eventTypeOptions } from '../utils/mics';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import moment from 'moment';
import { InputText } from 'primereact/inputtext';

const GenerateXmlEvent = ({ tooltipText = "Generate XML File", toast }) => {

    const [isDialogVisible, setIsDialogVisible] = useState(false);
    const downloadIconRef = useRef(null);

    const formik = useFormik({
        initialValues: {
            templateTypes: '',
            trxDate: '',
            storeId: '',
            isManual: true
        },
        validate: (data) => {
            let errors = {};
            if (!data.templateTypes) {
                errors.templateTypes = 'Event Type is required.';
            }
            if (!data.trxDate) {
                errors.trxDate = 'Business Date is required.';
            }
            if (!data.storeId) {
                errors.storeId = 'Store ID is required.';
            }
            return errors; // Ensure errors are returned
        },
        onSubmit: (values) => {
            const data = {
                ...values,
                trxDate: values.trxDate ? moment(values.trxDate).format('YYYY-MM-DD') : ''
            };
            handleDialogConfirm(data);
        }
    });

    const maxDate = new Date();
    maxDate.setDate(maxDate.getDate() - 1);

    const handleDialogConfirm = async (payload) => {
        const token = storage.getToken();
        const URL = window?.config?.END_POINT;

        try {

            const params = new URLSearchParams(payload).toString();

            const response = await axios.get(`${URL}/context/webhook/event/fileprocess?${params}`, {
                headers: { Authorization: token }
            });

            if (response.status === 200) {
                toast?.current?.show({ severity: 'success', summary: 'Success', detail: response?.data?.message });
            } else {
                toast?.current?.show({ severity: 'error', summary: 'Error', detail: response?.data?.message });
            }
        } catch (error) {
            console.error("API call error:", error);
            toast?.current?.show({ severity: 'error', summary: 'Error', detail: error });
        }

        setIsDialogVisible(false);
    };

    return (
        <>
            <Button
                type="button"
                icon="pi pi-download download-icon"
                severity="info"
                className='tp'
                outlined
                label="Regenerate EOD XML"
                ref={downloadIconRef}
                onClick={() => setIsDialogVisible(true)}
                data-pr-tooltip={tooltipText}
            />

            <Dialog
                header="Regenerate EOD Events"
                visible={isDialogVisible}
                style={{ width: '40vw' }}
                onHide={() => setIsDialogVisible(false)}
                footer={
                    <div>
                        <Button label="Cancel" outlined severity="secondary" icon='pi pi-times' onClick={() => setIsDialogVisible(false)} />
                        <Button label="Submit" outlined onClick={formik.handleSubmit} icon='pi pi-save' className="p-button-success mr-2" />
                    </div>
                }
            >
                <div className="grid p-2 mt-3">
                    <div className="p-fluid formgrid grid w-full">
                        <div className="field col-12 md:col-6">
                            <label htmlFor="templateTypes">Event Type</label>
                            <Dropdown
                                value={formik.values.templateTypes}
                                onChange={(e) => formik.setFieldValue('templateTypes', e.value)}
                                options={eventTypeOptions}
                                id="templateTypes"
                                name="templateTypes"
                                optionLabel="name"
                                optionValue="code"
                                placeholder="Select Event Type"
                                className={formik.errors.templateTypes && formik.touched.templateTypes ? 'p-invalid' : ''}
                            />
                            {formik.errors.templateTypes && formik.touched.templateTypes && (
                                <small className="p-error">{formik.errors.templateTypes}</small>
                            )}
                        </div>

                        <div className="field col-12 md:col-6">
                            <label htmlFor="trxDate">Business Date</label>
                            <Calendar
                                id="trxDate"
                                name="trxDate"
                                value={formik.values.trxDate}
                                onChange={(e) => formik.setFieldValue('trxDate', e.value)}
                                dateFormat="dd-mm-yy"
                                showIcon
                                maxDate={maxDate}
                                placeholder="dd-mm-yy"
                                className={formik.errors.trxDate && formik.touched.trxDate ? 'p-invalid' : ''}
                            />
                            {formik.errors.trxDate && formik.touched.trxDate && (
                                <small className="p-error">{formik.errors.trxDate}</small>
                            )}
                        </div>

                        <div className="field col-12">
                            <label htmlFor="storeId">Store ID(s)</label>
                            <InputText
                                id="storeId"
                                name="storeId"
                                value={formik.values.storeId}
                                onChange={(e) => formik.setFieldValue('storeId', e.target.value)}
                                placeholder="Enter multiple Store ID(s), separated by commas (e.g., 101, 102, 103)"
                                className={formik.errors.storeId && formik.touched.storeId ? 'p-invalid' : ''}
                            />
                            {formik.errors.storeId && formik.touched.storeId && (
                                <small className="p-error">{formik.errors.storeId}</small>
                            )}
                        </div>
                    </div>
                </div>
            </Dialog>
        </>
    );
};

export default GenerateXmlEvent;